import React, { createContext, useEffect, useState, useContext } from "react";

const CrawlingChatbotContext = createContext(null);

export const useCrawlingChatbotAuth = () => {
  return useContext(CrawlingChatbotContext);
};

export const CrawlingChatbotAuthProvider = ({ children }) => {
  // Initialize from localStorage so refreshes respect existing token
  const [isCrawlingChatbotAuthenticated, setISCrawlingChatbotAuthenticated] = useState(
    () => Boolean(localStorage.getItem("crawling"))
  );

  // Helper to set auth true and optionally persist token
  const crawlingChatbotLogin = (token) => {
    if (token) {
      localStorage.setItem("crawling", token);
    }
    setISCrawlingChatbotAuthenticated(true);
  };

  // Clear token + auth state
  const crawlingChatbotLogout = () => {
    localStorage.removeItem("crawling");
    setISCrawlingChatbotAuthenticated(false);
  };

  // Sync with storage changes (e.g., another tab or manual clear)
  useEffect(() => {
    const handleStorage = () => {
      setISCrawlingChatbotAuthenticated(Boolean(localStorage.getItem("crawling")));
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <CrawlingChatbotContext.Provider
      value={{
        isCrawlingChatbotAuthenticated,
        crawlingChatbotLogin,
        crawlingChatbotLogout,
      }}
    >
      {children}
    </CrawlingChatbotContext.Provider>
  );
};
